var map = {
	"./authorize.svg": 1283,
	"./canceled.svg": 1284,
	"./capture.svg": 1285,
	"./card-authentication-line.svg": 1286,
	"./collect-card.svg": 1287,
	"./created.svg": 1288,
	"./failed.svg": 1289,
	"./processing.svg": 1290,
	"./requires-action-line.svg": 1291,
	"./requires-confirmation.svg": 1292,
	"./requires-payment-method.svg": 1293,
	"./succeeded.svg": 1294,
	"./verified.svg": 1295
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1282;